import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Notice } from '../resources/types/noticesTypes';
import { noticesApi } from '../redux/api/noticesApi';
import { selectAdmins } from '../redux/slices/adminsSlice';
import { shouldShowNotification } from '../utils/notificationsSettings';

let dismissedNoticesCache: string[] = [];

const getDismissedNotices = (): string[] => {
  return dismissedNoticesCache;
};

const addDismissedNotices = (noticeIds: string[]): void => {
  dismissedNoticesCache = Array.from(new Set([...dismissedNoticesCache, ...noticeIds]));
};


export const useNotifications = () => {
  const [newNotices, setNewNotices] = useState<Notice[]>([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const admins = useSelector(selectAdmins);
  const selectedCityId = admins.currentCity;

  const { data: unviewedNoticesData } = noticesApi.useGetNoticesQuery({
    viewed: 'false',
    limit: 100,
    page: 1
  }, {
    pollingInterval: 30000
  });

  useEffect(() => {
    if (!shouldShowNotification()) {
      setNewNotices([]);
      return;
    }

    if (unviewedNoticesData?.adminNotices) {
      const dismissedIds = getDismissedNotices();
      
      const filteredNotices = selectedCityId
        ? unviewedNoticesData.adminNotices.filter(notice => {
            if (!notice.city) return true;
            const cityId = typeof notice.city === 'string' ? notice.city : notice.city._id;
            return cityId === selectedCityId;
          })
        : unviewedNoticesData.adminNotices;
      
      const notDismissedNotices = filteredNotices.filter(
        notice => !dismissedIds.includes(notice._id)
      );
      
      setNewNotices(notDismissedNotices.slice(0, 10));
    } else {
      setNewNotices([]);
    }
  }, [unviewedNoticesData, selectedCityId, refreshTrigger]);

  const clearNotifications = useCallback(() => {
    const noticeIds = newNotices.map(n => n._id);
    addDismissedNotices(noticeIds);
    setNewNotices([]);
  }, [newNotices]);

  const forceRefresh = useCallback(() => {
    setRefreshTrigger(prev => prev + 1);
  }, []);

  return {
    newNotices,
    hasNotifications: newNotices.length > 0,
    clearNotifications,
    forceRefresh
  };
};
